export const ApiStatus = {
  initial: 'initial',
  progress: 'progress',
  success: 'success',
  error: 'error'
}
